export default __webpack_public_path__ + "static/media/no_course_logo.7a5466e4.jpg";